import React from "react";
import "./Header.css";
import { useAuthStore } from "../../store/authStore";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export const Header = ({ path }) => {
  const logout = useAuthStore((state) => state.logout);

  const handleLogOut = () => {
    logout();
    localStorage.clear();
    toast.success("Logged Out Successfully!")
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src="bark-nw-logo.png" alt="bark-logo" />
      </div>
      <h1>Tree Bark Validation</h1>
      {path !== "/login" ? (
        <div className="profile-container">
          <button onClick={handleLogOut}>Log Out</button>
          <img src="profile-black.svg" alt="profile-logo" />
        </div>
      ) : (
        <div className="profile-container">
          <Link to="/login">
            <button>Login</button>
          </Link>
        </div>
      )}
    </header>
  );
};
